import Isotope from "isotope-layout";
import Flickity from "flickity";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import inView from "in-view";
gsap.registerPlugin(ScrollToPlugin);
const HTML = document.querySelector("html");
class App2 {
  constructor() {
    document.addEventListener("is-init", () => {
      const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');
      if (anchorLinks) {
        anchorLinks.forEach((link) => {
          link.addEventListener("click", (e) => {
            e.stopPropagation();
            e.preventDefault();
            const target = document.querySelector(link.getAttribute("href"));
            if (target) {
              e.preventDefault();
              gsap.to(window, {
                scrollTo: {
                  y: target,
                  offsetY: 150
                },
                duration: 0.5,
                ease: "expo.inOut"
              });
            }
          });
        });
      }
      const toggleMenu = document.querySelectorAll(".toggle-menu");
      if (toggleMenu) {
        toggleMenu.forEach((toggle) => {
          let timer = 0;
          toggle.addEventListener("click", () => {
            clearTimeout(timer);
            if (HTML.classList.contains("open-submenu") && !HTML.classList.contains("open-menu")) {
              timer = setTimeout(() => {
                HTML.classList.remove("open-submenu");
              }, 300);
            }
          });
        });
      }
      this.submenu();
      this.isotopeGrid();
      this.carousel();
      this.inViewport();
    });
  }
  submenu() {
    const submenuLinks = document.querySelectorAll(".main-nav .menu-item-has-children");
    if (submenuLinks) {
      submenuLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          if (window.innerWidth < 992) {
            e.preventDefault();
            e.stopPropagation();
            HTML.classList.add("open-submenu");
            link.classList.add("show");
          }
        });
        const back = link.querySelector(".back");
        if (back) {
          back.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            HTML.classList.remove("open-submenu");
            link.classList.remove("show");
          });
        }
      });
    }
  }
  isotopeGrid() {
    const elts = document.querySelectorAll(".isotope-grid");
    if (elts) {
      elts.forEach((el) => {
        new Isotope(el, {
          itemSelector: ".item",
          layoutMode: "masonry"
        });
      });
    }
  }
  carousel() {
    const elts = document.querySelectorAll(".carousel");
    if (elts) {
      elts.forEach((el) => {
        new Flickity(el, {
          groupCells: true,
          cellAlign: "left",
          contain: true,
          arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
          }
        });
      });
    }
  }
  inViewport() {
    inView.offset({
      bottom: window.innerHeight * 0.1
    });
    inView(".js-reveal:not(.is-visible)").on("enter", function(elt) {
      elt.dispatchEvent(new Event("inview"));
      elt.classList.add("is-visible");
      elt.classList.remove("not-visible");
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true" || video && video.dataset.autoplay == "true") {
        const v = video || elt;
        const playPromise = v.play();
        if (playPromise !== null) {
          playPromise.catch(() => {
            v.play();
          });
        }
      }
    }).on("exit", function(elt) {
      const video = elt.querySelector("video");
      if (elt.tagName == "VIDEO" && elt.dataset.autoplay != "" || video && video.dataset.autoplay != "") {
        const v = video || elt;
        v.pause();
      }
      elt.dispatchEvent(new Event("outview"));
      elt.classList.add("not-visible");
    });
  }
}
window.addEventListener("DOMContentLoaded", () => {
  new App2();
});


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
